<script lang="ts" setup></script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0627 16.1652H1.66699L1.7564 16.0132C2.58505 14.6044 3.02201 12.9998 3.02201 11.3655V6.68005C3.02201 4.91854 5.24423 1.6665 9.79707 1.6665C14.3499 1.6665 16.5721 5.05404 16.5721 6.68005V11.1546C16.5721 12.9216 17.0828 14.6509 18.0427 16.1344L18.0627 16.1652Z"
      stroke="#4D4E58"
      stroke-width="1.16667"
    />
    <path
      d="M9.79742 18.3331C7.8462 18.3331 7.3584 16.8877 7.3584 16.165H12.3719C12.3268 16.8877 11.7486 18.3331 9.79742 18.3331Z"
      stroke="#4D4E58"
      stroke-width="1.16667"
    />
  </svg>
</template>
